import axios from 'axios'
// import router from '../router'

export default ({
    namespaced: true,
    state: {
        certificado: null
    },

    getters:{
        //
    },

    mutations: {
        SET_CERT(state, data) {
            state.certificado = data
        }
    },

    actions: {
        getDocument({commit,dispatch}, data)
        {
            commit('SET_CERT', data.docName);
            const subFolder = data.subFolder ? `${data.subFolder}-` : '';
            const docName = data.docName;

            axios({
                url: `/download/${data.docType}/${subFolder}${docName}`,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', `${data.docName}.pdf`);
                document.body.appendChild(fileLink);

                fileLink.click();
            }).catch((e) => {
                if (e.response.status == 404 ){
                    dispatch('auth/setAuthErrors', "El archivo que intenta descargar no se ha encontrado.", { root: true })
                    return false;
                }
            });
        }
    }
})
